// src/contexts/CartContext.js
import { createContext, useState, useContext } from 'react';
import Cookies from "js-cookie";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cartCount, setCartCount] = useState(0);
    // Function to update cart count (call after adding to cart)
    const updateCartCount = async () => {
        const userId = Cookies.get("userId");
        if (!userId) return;
        const formData = new FormData();
        formData.append("user_id", userId);
        const response = await fetch("https://leapatinternational.com/admin/api/v1/web_getcart.php", {
            method: "POST",
            body: formData,
        });
        const result = await response.json();
        const items = result.data || result.items || [];
        setCartCount(items.length); // ✅ Update state
    };


    return (
        <CartContext.Provider value={{ cartCount, updateCartCount }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);